export default __webpack_public_path__ + "static/media/Northern Frostcape.7779aa6e.jpg";